// src/pages/UserPage.jsx
import React, { useEffect, useState } from 'react';
import { obtenerUsuarioAutenticado } from '../api';

const UserPage = () => {
  const [user, setUser] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    obtenerUsuarioAutenticado()
      .then(data => {
        setUser(data);
        setCargando(false);
      })
      .catch(() => {
        setCargando(false);
        // Redireccionar si no está autenticado
        window.location.href = '/login';
      });
  }, []);

  if (cargando) return <p>Cargando...</p>;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Perfil del Usuario</h1>
      {user ? (
        <div className="mt-4">
          <p><strong>Nombre:</strong> {user.name}</p>
          <p><strong>Usuario:</strong> {user.username}</p>
          <p><strong>Email:</strong> {user.email}</p>
        </div>
      ) : (
        <p>No estás autenticado.</p>
      )}
    </div>
  );
};

export default UserPage;
